export default __webpack_public_path__ + "static/media/Coiny-Regular.61e71214.ttf";